import { FlightsSearchFormJourneyCriteriaType } from 'src/types/search/wizard';

export const getValidStartDate = (journeys: FlightsSearchFormJourneyCriteriaType[], index: number): string => {
  if (index === 0) {
    return '';
  }

  for (let i = index - 1; i >= 0; i--) {
    const previousJourneyDate = journeys[i].departureDate?.date?.isoFormat;

    if (previousJourneyDate) {
      return previousJourneyDate;
    }
  }
};
